import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'WaterQualityGroup';

export type WaterQualityGroupProps = {
  // All not needed?
};

export class WaterQualityGroup extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }
  // All not needed?

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      NitrateLevel: {
        type: 'RelatedType',
        editable: false,
        label: 'Nitrate Level',
        name: 'NitrateLevel',
        description: 'Nitrate Level (N03) for grouped and individual Water Nitrate objects ',
        objectTypeId: 'Nitrate_Readings|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_NitrateLevel_Nitrate_Readings|P',
      },
      NitrateChanges: {
        type: 'RelatedType',
        editable: false,
        label: 'Nitrate Changes',
        name: 'NitrateChanges',
        description: 'Amount of change in nitrates (N03) between two periods for grouped and individual Water Nitrate objects ',
        objectTypeId: 'Nitrate_Readings|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_NitrateChanges_Nitrate_Readings|P',
      },
      WaterTemperature: {
        type: 'RelatedType',
        editable: false,
        label: 'Water Temperature',
        name: 'WaterTemperature',
        description: 'Water Temperature (°C)  for grouped and individual Water Nitrate and Water Turbidity objects ',
        objectTypeId: 'Nitrate_Readings|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_WaterTemperature_Nitrate_Readings|P',
      },
      TurbidityLevel: {
        type: 'RelatedType',
        editable: false,
        label: 'Turbidity Level',
        name: 'TurbidityLevel',
        description: 'Turbidity Level (NTU) for grouped and individual Water Turbidity objects ',
        objectTypeId: 'Turbidity_Readings|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_TurbidityLevel_Turbidity_Readings|P',
      },
      TurbidityChange: {
        type: 'RelatedType',
        editable: false,
        label: 'Turbidity Change',
        name: 'TurbidityChange',
        description: 'Amount of change in turbidity (NTU) between two periods for grouped and individual Water Turbidity objects ',
        objectTypeId: 'Turbidity_Readings|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_TurbidityChange_Turbidity_Readings|P',
      },
      NitrateContributionMargin: {
        type: 'RelatedType',
        editable: false,
        label: 'Nitrate Contribution Margin',
        name: 'NitrateContributionMargin',
        description: 'Nitrate Level (N03) for individual Water Nitrate objects at the entry and exit points of the water area',
        objectTypeId: 'Water_Quality_Group|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_NitrateContributionMargin_Water_Quality_Group|P',
      },
      NitrateContributionMarginChange: {
        type: 'RelatedType',
        editable: false,
        label: 'Nitrate Contribution Margin Change',
        name: 'NitrateContributionMarginChange',
        description: 'Amount of change in the nitrate contribution margin (N03) between two periods',
        objectTypeId: 'Water_Quality_Group|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_NitrateContributionMarginChange_Water_Quality_Group|P',
      },
      TurbidityContributionMargin: {
        type: 'RelatedType',
        editable: false,
        label: 'Turbidity Contribution Margin',
        name: 'TurbidityContributionMargin',
        description: 'Turbidity Level (NTU) for individual Water Turbidity objects at the entry and exit points of the water area',
        objectTypeId: 'Turbidity_Readings|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_TurbidityContributionMargin_Turbidity_Readings|P',
      },
      TurbidityContributionMarginChange: {
        type: 'RelatedType',
        editable: false,
        label: 'Turbidity Contribution Margin Change',
        name: 'TurbidityContributionMarginChange',
        description: 'Amount of change in the turbidity contribution margin (NTU) between two periods',
        objectTypeId: 'Water_Quality_Group|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Water_Quality_Group_has_TurbidityContributionMarginChange_Water_Quality_Group|P',
      },
    };
  };
}
